// src/components/Skills.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { 
  SiCsharp, SiRuby, SiPython, SiJavascript, SiTypescript,
  SiDotnet, SiRubyonrails, SiFlask,
  SiReact, SiBootstrap, SiHtml5, SiCss3,
  SiMicrosoftsqlserver, SiMongodb, SiPostgresql, SiMicrosoftazure,
  SiDocker, SiGit, SiVisualstudio, SiPostman, SiVercel, SiGithubactions
} from 'react-icons/si';
import { FaCloud } from 'react-icons/fa';
import './Skills.css';

const Skills = ({ t }) => {
  const skillCategories = [
    {
      title: t.skills.categories.languages,
      color: 'blue',
      skills: [
        { name: 'C#', icon: <SiCsharp /> },
        { name: 'Ruby', icon: <SiRuby /> },
        { name: 'Python', icon: <SiPython /> },
        { name: 'JavaScript', icon: <SiJavascript /> },
        { name: 'TypeScript', icon: <SiTypescript /> }
      ]
    },
    {
      title: t.skills.categories.backend,
      color: 'green',
      skills: [
        { name: '.NET', icon: <SiDotnet /> },
        { name: '.NET Core', icon: <SiDotnet /> },
        { name: 'Ruby on Rails', icon: <SiRubyonrails /> },
        { name: 'Flask', icon: <SiFlask /> },
        { name: 'ASP.NET Core', icon: <SiDotnet /> }
      ]
    },
    {
      title: t.skills.categories.frontend,
      color: 'cyan',
      skills: [
        { name: 'React', icon: <SiReact /> },
        { name: 'WPF', icon: <FaCloud /> },
        { name: 'Bootstrap', icon: <SiBootstrap /> },
        { name: 'HTML5', icon: <SiHtml5 /> },
        { name: 'CSS3', icon: <SiCss3 /> }
      ]
    },
    {
      title: t.skills.categories.databases,
      color: 'purple',
      skills: [
        { name: 'SQL Server', icon: <SiMicrosoftsqlserver /> },
        { name: 'MongoDB', icon: <SiMongodb /> },
        { name: 'PostgreSQL', icon: <SiPostgresql /> },
        { name: 'Azure Blob', icon: <SiMicrosoftazure /> }
      ]
    },
    {
      title: t.skills.categories.cloud,
      color: 'pink',
      skills: [
        { name: 'Azure', icon: <SiMicrosoftazure /> },
        { name: 'Service Fabric', icon: <FaCloud /> },
        { name: 'Docker', icon: <SiDocker /> },
        { name: 'Docker Compose', icon: <SiDocker /> }
      ]
    },
    {
      title: t.skills.categories.tools,
      color: 'green',
      skills: [
        { name: 'Git', icon: <SiGit /> },
        { name: 'Visual Studio', icon: <SiVisualstudio /> },
        { name: 'Postman', icon: <SiPostman /> },
        { name: 'Vercel', icon: <SiVercel /> },
        { name: 'GitHub Actions', icon: <SiGithubactions /> }
      ]
    }
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <section className="skills" id="skills">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title neon-text">{t.skills.title}</h2>
          <p className="skills-subtitle">{t.skills.subtitle}</p>

          <motion.div 
            className="skills-grid"
            variants={container}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            {skillCategories.map((category, catIndex) => (
              <div
                key={catIndex}
                className={`skill-category neon-border-${category.color}`}
              >
                <h3 className={`category-title neon-text-${category.color}`}>
                  {category.title}
                </h3>
                
                <div className="skills-list">
                  {category.skills.map((skill, skillIndex) => (
                    <motion.div
                      key={skillIndex}
                      className="skill-item"
                      variants={item}
                    >
                      <div className={`skill-icon skill-icon-${category.color}`}>
                        {skill.icon}
                      </div>
                      <span className="skill-name">{skill.name}</span>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
